// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useModuleParty } from '../../contexts/ModuleContext';
import { baseRoutes, operatorRoutes, userRoutes } from '../../modules/CollateralV2/routes';
import { useCollateralUserServiceV2 } from '../queries/collateralv2/onboarding/useUserService';
import { useOperatorParty } from '../queries/utility-operator/useOperatorParty';

export const useCollateralEntriesV2 = () => {
  const userService = useCollateralUserServiceV2();
  const operator = useOperatorParty()?.data;
  const party = useModuleParty();

  const isOperator = party === operator;
  const isUser = !!userService.data;
  let entries = baseRoutes;

  if (isOperator) {
    entries = entries.concat(operatorRoutes);
  }

  if (isUser) {
    entries = entries.concat(userRoutes);
  }

  return entries;
};
